import axios from 'axios'
import Cookies from 'js-cookie'

// state
export const state = {
  user: null,
  token: Cookies.get('token'),
  classId: JSON.parse(localStorage.getItem('userClass')),
}

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  check: state => !(state.user === null || state.user === undefined),
  classId: state => state.classId,
  firstName: state => state.user.name.split(' ')[0],
}

// actions
export const actions = {
  saveToken({ commit, dispatch }, payload) {
    commit('SAVE_TOKEN', payload)
  },

  setClassId({ commit }, payload) {
    commit('SET_CLASS_ID', payload)
  },

  async fetchUser({ commit }) {
    try {
      const { data } = await axios.get('/api/user')

      commit('FETCH_USER_SUCCESS', { user: {...data, firstName: data.name.split(" ")[0]} })
    } catch (e) {
      commit('FETCH_USER_FAILURE')
    }
  },

  updateUser({ commit }, payload) {
    commit('UPDATE_USER', { user: {...payload.user, firstName: payload.user.name.split(" ")[0]} })
  },

  async logout({ commit }) {
    try {
      await axios.post('/api/logout')
      Cookies.remove('state')
    } catch (e) {}

    commit('LOGOUT')
  },

  async fetchOauthUrl(ctx, { provider }) {
    const { data } = await axios.post(`/api/oauth/${provider}`)

    return data.url
  },
}

// mutations
export const mutations = {
  SAVE_TOKEN(state, { token, remember }) {
    state.token = token
    Cookies.set('token', token, { expires: remember ? 365 : null })
  },

  SET_CLASS_ID(state, payload ) {
    state.classId = payload
  },

  FETCH_USER_SUCCESS(state, { user }) {
    state.user = user
  },

  FETCH_USER_FAILURE(state) {
    state.token = null
    Cookies.remove('token')
  },

  LOGOUT(state) {
    state.user = null
    state.token = null
    state.classId = null

    Cookies.remove('token')
  },

  UPDATE_USER(state, { user }) {
    state.user = user
  },
}
